import {
  Accordion,
  AccordionItem,
  AccordionItemState,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import { FC } from "react";
import styled from "styled-components/macro";
import { DPIconAdd, DPIconRemove } from "../assets/icons";
import Typography from "./typography";
import Theme from "../constants/Theme";

type DPAType = { data: Array<{ title: string; body: string }> };

const DotPayAccordion: FC<DPAType> = ({ data }) => {
  return (
    <Styling>
      <Accordion allowZeroExpanded>
        {data.map(({ title, body }, index) => (
          <AccordionItem key={index.toString()}>
            <AccordionItemHeading>
              <AccordionItemButton>
                <AccordionItemState>
                  {({ expanded }) =>
                    expanded ? <DPIconRemove /> : <DPIconAdd />
                  }
                </AccordionItemState>
                <Typography.Heading
                  fontType="Galano Alt"
                  weight="semiBold"
                  className="accordion__text-title"
                  color="darkBlue"
                  level={5}
                  uppercase
                >
                  {title}
                </Typography.Heading>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <Typography.Text
                style={{
                  fontSize: Theme.fontSizes.xlarge,
                }}
                weight="normal"
                fontType="Galano"
              >
                {body}
              </Typography.Text>
            </AccordionItemPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </Styling>
  );
};

const Styling = styled.div`
  background: ${Theme.colorPalette.offWhite};
  .accordion {
    background: ${Theme.colorPalette.offWhite};
    border: none;
    &__item {
      margin: 0 0 10px 0;
    }
    &__button:hover {
      background: ${Theme.colorPalette.offWhite};
    }
    &__button:before {
      display: none;
    }
    &__button {
      display: flex;
      align-items: center;
      > h5 {
        margin-left: 10px;
        @media screen and (min-width: 768px) {
          font-size: ${Theme.fontSizes.xxlarge};
          margin-left: 32px;
        }
      }
    }
    &__panel {
      background: ${Theme.colorPalette.white};
      border: 1px solid #fafafa;
      padding: 0;
      @media screen and (min-width: 768px) {
        padding: 24px 70px;
      }
    }
  }
`;

export default DotPayAccordion;
